import { usePermissionStore } from '@/store/modules/permission'

// 按钮权限接口
export interface ButtonPermission {
  menuCode: string
  menuName: string
  perms: string
  path: string
  parentId: string
  parentName?: string
}

/**
 * 从路由数据中提取按钮权限
 * @param routes 路由数据
 * @returns 按钮权限列表
 */
export const extractButtonPermissions = (routes: any[]): ButtonPermission[] => {
  const buttonPermissions: ButtonPermission[] = []
  const extractFromRoutes = (routeList: any[], parentName?: string) => {
    routeList.forEach((route) => {
      // 检查是否有按钮权限信息
      if (route.menuType === 'BUTTON') {
        buttonPermissions.push({
          menuCode: route.menuCode,
          menuName: route.menuName,
          perms: route.perms,
          path: route.path,
          parentId: route.parentId,
          parentName: parentName
        })
      }

      // 递归处理子路由
      if (route.children && route.children.length > 0) {
        extractFromRoutes(route.children, route.menuName)
      }
    })
  }

  extractFromRoutes(routes)
  return buttonPermissions
}

/**
 * 检查是否有指定权限
 * @param permissionCode 权限编码
 * @param buttonPermissions 按钮权限列表
 * @returns 是否有该权限
 */
let permissionStore: ReturnType<typeof usePermissionStore> | null = null
export const hasButtonPermission = (permissionCode: string): boolean => {
  // 延迟获取 store 实例
  if (!permissionStore) {
    permissionStore = usePermissionStore()
  }
  const buttonPermissions = permissionStore.getButtonPermissions
  return buttonPermissions.some(
    (permission) => permission.perms === permissionCode || permission.menuCode === permissionCode
  )
}
